"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const grid_observer_1 = require("@ebay-business-components/grid-observer");
class default_1 extends Marko.Component {
    onCreate(input) {
        const { width, height } = input;
        const hasDimensions = typeof width === 'number' && typeof height === 'number';
        this.state = {
            width: hasDimensions ? width : null,
            height: hasDimensions ? height : null,
            aspectRatio: hasDimensions ? (0, grid_observer_1.getAspectRatio)(width, height) : null,
            loaded: false,
        };
    }
    handleLoad(e) {
        if (e.target instanceof HTMLImageElement) {
            const { naturalWidth: width, naturalHeight: height } = e.target;
            const aspectRatio = (0, grid_observer_1.getAspectRatio)(width, height);
            const [widthString, heightString] = aspectRatio.split('/');
            this.state.width = parseInt(widthString);
            this.state.height = parseInt(heightString);
            this.state.aspectRatio = aspectRatio;
            this.state.loaded = true;
        }
    }
}
exports.default = default_1;
//# sourceMappingURL=component.js.map